export default __webpack_public_path__ + "static/media/INCIDENTS_Final.fea08ed1.jpg";